import React from 'react';

const FormatKeyToLabel = ({ value, uppercase = false }) => {
  if (!value) return null;

  const formatted = value.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  return <span>{uppercase ? formatted.toUpperCase() : formatted}</span>;
};

export default FormatKeyToLabel;
